interface ParseFluidOptionDirectional {
	variant: boolean | FluidVariantDirectional;
	direction: 'vertical' | 'horizontal';
}

interface ParseFluidNonDirectional {
	variant: FluidVariantHorizontal | FluidVariantVertical | FluidVariantAll;
	direction?: string;
}

interface ParseFluidNone {
	variant?: undefined;
	direction?: undefined;
}

export type ParseFluidOption = ParseFluidOptionDirectional | ParseFluidNonDirectional | ParseFluidNone;

export function parseFluid({ variant, direction }: ParseFluidOption): FluidResultUnion {
	if (variant == null) return {};

	let fluidVariant: FluidHorizontal | FluidVertical | FluidDirectional | FluidAll | FluidNone;
	if (typeof variant === 'boolean') {
		if (!variant) return {};

		fluidVariant = 'directional';
	} else {
		fluidVariant = variant;
	}

	if (fluidVariant === 'all') {
		return {
			width: '100%',
			height: '100%',
		};
	}

	if (fluidVariant === 'vertical') {
		return {
			height: '100%',
		};
	}

	if (fluidVariant === 'horizontal') {
		return {
			width: '100%',
		};
	}

	if (direction == null) {
		throw new TypeError('ParseFluid is missing direction');
	}

	return direction === 'vertical' ? { height: '100%' } : { width: '100%' };
}

type FluidVariantHorizontal = 'horizontal';
interface FluidHorizontal {
	width: '100%';
}

type FluidVariantVertical = 'vertical';
interface FluidVertical {
	height: '100%';
}

interface FluidNone {}

type FluidVariantDirectional = 'directional';
type FluidDirectional = FluidHorizontal | FluidHorizontal;

type FluidVariantAll = 'all';
type FluidAll = FluidHorizontal & FluidHorizontal;

type FluidResultUnion = FluidHorizontal | FluidVertical | FluidDirectional | FluidAll | FluidNone;

export type FluidProp = ParseFluidOptionDirectional['variant'] | ParseFluidOption['variant'];
